<script>
  import { createEventDispatcher, onMount } from "svelte";
  import axios from "axios";
  import config from "../stores/config";
  import * as ls from "local-storage";
  import t from "../utils/t";

  export let _id;
  export let fullname;
  export let tel;
  export let email;
  export let country;
  export let username;
  export let role;

  const dispatch = createEventDispatcher();

  const handleDelete = () => {
    if (role == "super-admin") {
      alert("⚠ The Super Admin Cannot Be Deleted!");
      return;
    }

    let confirmDelete = confirm(
      `❌ ${t({
        en: "Voulez-vous supprimer",
        fr: "Voulez-vous supprimer",
      })} ${fullname}?`
    );

    if (confirmDelete) {
      axios
        .delete(`${$config.backendURL}/users/${_id}`, {
          headers: { authorization: ls.get("jwt") },
        })
        .then((res) => {
          dispatch("delete");
        })
        .catch((err) => {
          console.log(err);
          alert(err);
        });
    }
  };
</script>

<div
  class="px-4 py-4 rounded-md shadow-sm bg-gradient-to-r from-gray-50 to-gray-100"
>
  <div class="flex justify-between">
    <div class="flex items-center">
      <h1 class="font-semibold uppercase line-clamp-1">
        {fullname}
      </h1>
    </div>
  </div>

  <div class="expanded-menu border-t border-gray-100 pt-2">
    <h1 class="text-sm tracking-wider text-brand-orange flex items-center mb-3">
      <ion-icon name="at-circle" class="text-2xl mr-2" />
      — {username}
    </h1>
    <h1
      class="text-xs tracking-wider uppercase text-green-600 flex items-center mb-3"
    >
      <ion-icon name="globe" class="text-2xl mr-2" />
      — {country}
    </h1>

    <h1 class="pb-2">
      Telephone:
      <a
        target="_blank"
        href={`tel:+${tel.replace("+", "").replaceAll("-", "")}`}
      >
        {tel}
      </a>
    </h1>

    <div class="mt-3 grid grid-cols-4 gap-3">
      <a
        target="_blank"
        class="flex items-center justify-center rounded-lg shadow-sm py-1 px-3 bg-gradient-to-r from-brand-white to-gray-50"
        href={`tel:+${tel.replace("+", "").replaceAll("-", "")}`}
      >
        <ion-icon name="call" class="text-2xl" />
      </a>
      <a
        target="_blank"
        class="shadow-sm flex items-center justify-center rounded-lg py-1 px-3 bg-gradient-to-r from-brand-white to-gray-50"
        href={`https://wa.me/${tel
          .replace("+", "")
          .replaceAll("-", "")
          .replaceAll(" ", "")}`}
      >
        <ion-icon name="logo-whatsapp" class="text-2xl" />
      </a>
      <a
        target="_blank"
        class="shadow-sm flex items-center justify-center rounded-lg py-1 px-3 bg-gradient-to-r from-brand-white to-gray-50"
        href={`mailto:${email}`}
      >
        <ion-icon name="mail" class="text-2xl" />
      </a>
      <button
        on:click={handleDelete}
        class="shadow-sm flex items-center justify-center rounded-lg py-1 px-3 bg-gradient-to-r from-red-200 to-red-100"
      >
        <ion-icon name="trash" class="text-2xl text-red-500" />
      </button>
    </div>
  </div>
</div>
